import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const AgentHome = () => import('./Index.vue');
const EditAgent = () => import('./EditAgent.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/agents-ia'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'AGENT_MGMT.HEADER',
        icon: 'people',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'agents-ia',
          component: AgentHome,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':agentId/edit',
          name: 'agentia_edit',
          component: EditAgent,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
